import { render, staticRenderFns } from "./HistoricoSeccion.vue?vue&type=template&id=d34959ac&scoped=true"
import script from "./HistoricoSeccion.vue?vue&type=script&lang=js"
export * from "./HistoricoSeccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34959ac",
  null
  
)

export default component.exports